const baseProfile = {
  layout: 'default',
  homeLabel: 'Inicio',
  allLabel: 'Ver todos',
  showIndex: true,
  maxCategories: 8,
  showStrip: false,
  stripAriaLabel: 'Categorías principales',
  searchPlaceholder: 'Buscar...',
};

export const DESIGN_MENU_PROFILES = {
  'bazar-lumina': {
    layout: 'bazar',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Secciones del bazar',
    searchPlaceholder: 'Buscar...',
  },
  'tecno-pulse': {
    layout: 'tech-command',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 7,
    stripAriaLabel: 'Comando de categorías',
    searchPlaceholder: 'Buscar...',
  },
  'hombre-atelier': {
    layout: 'atelier',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Colecciones destacadas',
    searchPlaceholder: 'Buscar...',
  },
  'mujer-maison': {
    layout: 'maison',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Colecciones boutique',
    searchPlaceholder: 'Buscar...',
  },
  'deco-serena': {
    layout: 'interior',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Ambientes y categorías',
    searchPlaceholder: 'Buscar...',
  },
  'kids-pop': {
    layout: 'play-pop',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 8,
    stripAriaLabel: 'Categorías principales',
    searchPlaceholder: 'Buscar...',
  },
  'beauty-glow': {
    layout: 'glow',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Rutinas y líneas beauty',
    searchPlaceholder: 'Buscar...',
  },
  'sport-grid': {
    layout: 'scoreboard',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Categorías deportivas',
    searchPlaceholder: 'Buscar...',
  },
  'pet-friendly': {
    layout: 'friendly',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Categorías de cuidado',
    searchPlaceholder: 'Buscar...',
  },
  'gourmet-fresh': {
    layout: 'market-fresh',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Pasillos del mercado',
    searchPlaceholder: 'Buscar...',
  },
  'urban-drop': {
    layout: 'drop',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Navegación del drop',
    searchPlaceholder: 'Buscar...',
  },
  'prisma-joyas': {
    layout: 'prisma-studio',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Colecciones Prisma',
    searchPlaceholder: 'Buscar...',
  },
  'papel-vivo': {
    layout: 'reader',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 7,
    stripAriaLabel: 'Categorías principales',
    searchPlaceholder: 'Buscar...',
  },
  'nordika-home': {
    layout: 'nordic',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Ambientes del hogar',
    searchPlaceholder: 'Buscar...',
  },
  'auto-pro': {
    layout: 'garage',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Categorías técnicas',
    searchPlaceholder: 'Buscar...',
  },
  'farma-clara': {
    layout: 'health-tabs',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Categorías de salud',
    searchPlaceholder: 'Buscar...',
  },
  'toolbox-pro': {
    layout: 'workbench',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Herramientas y categorías',
    searchPlaceholder: 'Buscar...',
  },
  'raiz-artesanal': {
    layout: 'craft',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Piezas y colecciones',
    searchPlaceholder: 'Buscar...',
  },
  'neon-gamer': {
    layout: 'neon-command',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Menú gamer',
    searchPlaceholder: 'Buscar...',
  },
  'terra-outdoor': {
    layout: 'trail',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Rutas y categorías outdoor',
    searchPlaceholder: 'Buscar...',
  },
  'moda-mayorista': {
    layout: 'wholesale-fashion',
    homeLabel: 'Inicio',
    allLabel: 'Ver todos los productos',
    showIndex: false,
    showStrip: true,
    maxCategories: 50,
    stripAriaLabel: 'Colecciones y categorías',
    searchPlaceholder: 'Buscar...',
  },
};

export const getDesignMenuProfile = (slug) => ({
  ...baseProfile,
  ...(DESIGN_MENU_PROFILES[slug] || {}),
  allLabel: 'Ver todos',
  showIndex: false,
  searchPlaceholder: 'Buscar...',
});
